<template>
  <div class="servicios-hero-images">
    <img src="/img/servicios/servicios.webp" alt="Fondo de servicios de Tasoar" class="pantalla-completa">
    <img src="/img/servicios/servicios-movil.webp" alt="Fondo de servicios de Tasoar" class="pantalla-movil">
  </div>
</template>

<style scoped>
.pantalla-completa,
.pantalla-movil {
  width: 100%;
  height: auto;
  display: block; /* Quita el espacio fantasma que dejan las imágenes inline */
}

.pantalla-completa {
  display: block;
}

.pantalla-movil {
  display: none;
}

@media (max-width: 768px) {
  .pantalla-completa {
    display: none;
  }
  .pantalla-movil {
    display: block;
  }
}
</style>